// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-21n1V","title":"title-fWt_P","button":"button-1dfzq","button_opened":"button_opened-3xI0L"};